module.exports = __webpack_public_path__ + "static/media/BrutalType-Medium.6a0ccd2a.woff";